import { useState } from "react";
import { getProfileYearInReviewUrl } from "@ugg/shared/routes/app-routes";
import { SvgYearInReviewShare } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewShare";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
interface ShareButtonProps {
  region: string;
  riotUserName: string;
  riotTagLine: string;
}

export function ShareButton(props: ShareButtonProps) {
  const [isCopied, setIsCopied] = useState(false);
  const { region, riotUserName, riotTagLine } = props;
  const BASE_URL = "https://u.gg";

  const handleCopyUrl = () => {
    const relativeUrl = getProfileYearInReviewUrl(region, riotUserName, riotTagLine);
    const urlToCopy = BASE_URL + relativeUrl;
    navigator.clipboard
      .writeText(urlToCopy)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 5000);
      })
      .catch((err) => {
        console.error("Failed to copy URL: ", err);
      });
  };

  const buttonText = isCopied ? "Copied!" : "Share";

  return (
    <button
      type="button"
      onClick={handleCopyUrl}
      className="flex items-center justify-center h-[48px] bg-[#25254B] cursor-pointer w-[48px] ml-[12px] p-[5px]
             shadow-[0_1px_0_0_#575792_inset,0_2px_4px_0_rgba(0,0,0,0.25)] rounded-[2px] xxxs:w-[240px] xxxs:ml-[18px] 
             xxxs:rounded-[3px]  xxxs:gap-[8px] xxxs:px-[12px] xxxs:shrink-0 xxxs:font-inter xxxs:text-[18px] xxs:whitespace-nowrap"
    >
      <Icon icon={<SvgYearInReviewShare />} size="md" className="text-[#D3A752]" />
      <span className="hidden xxxs:block">{buttonText}</span>
    </button>
  );
}
